import React from 'react';
import PropTypes from 'prop-types';
import { FormPageLayout } from '../../common';
import PrimaryDoctorDetails from './PrimaryDoctorDetails';
import PrimaryDoctorForm from './PrimaryDoctorForm';

function PrimaryDoctorPage({ primaryDoctor, ...rest }) {
  return (
    <FormPageLayout
      {...rest}
      data={primaryDoctor}
      formComponent={PrimaryDoctorForm}
      hasData={!!primaryDoctor.id}
      itemComponent={PrimaryDoctorDetails}
      title="Primary Doctor"
    />
  );
}

PrimaryDoctorPage.propTypes = {
  primaryDoctor: PropTypes.object,
};

PrimaryDoctorPage.defaultProps = {
  primaryDoctor: {},
};

export default PrimaryDoctorPage;



// WEBPACK FOOTER //
// ./src/modules/PrimaryDoctorPage/components/PrimaryDoctorPage.js